export const generateRandomNumber = () => {
	return Math.random().toString(36).substring(2);
};

export const toLowerTypeSensitive = (value: any) => {
	return (value.toLowerCase || (() => value)).call(value);
};

export const formatNumberWithCommas = (value: any) => {
	return value
		.toString()
		.replace(',', '')
		.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getComponentName = (name: string) => {
	switch (name) {
		case 'UnmaskedInput':
			return 'unmasked-input';

		case 'MaskedInput':
			return 'masked-input';

		case 'ButtonLink':
			return 'button-link';

		case 'Sectiontitle':
			return 'section-title';

		case 'Break':
			return 'break';

		case 'CustomTitle3':
			return 'custom-title-3';

		case 'FilledData':
			return 'filled-data';

		case 'CustomButton':
			return 'custom-button';

		case 'Quote':
			return 'quote';

		case 'CallMeNow':
			return 'call-me-now';

		case 'ProviderInfo':
			return 'provider-info';

		case 'InfoBlock':
			return 'info-block';

		case 'ResultPageToggleSection':
			return 'result-page-toggle-section';

		case 'Multiselect':
			return 'multi-select';

		case 'Map':
			return 'map';

		case 'CallProgressive':
			return 'call-progressive';

		case 'Comparison':
			return 'comparison';

		case 'ClickListItem':
			return 'click-list-item';

		case 'SchedulePanel':
			return 'schedule-panel';

		case 'talkWithUs':
			return 'talk-with-us';

		case 'InfoWeFound':
			return 'info-we-found';

		case 'InfoWeFoundMvp':
			return 'info-we-found-mvp';

		case 'ExtendedInfoWeFound':
			return 'extended-info-we-found';

		case 'StyledButtons':
			return 'styled-buttons';

		case 'PreferencesRanking':
			return 'preferences-ranking';

		case 'QuestionGroup':
			return 'question-group';

		case 'StyledButton':
			return 'styled-button';

		case 'CustomButtonList':
			return 'custom-button-list';

		case 'NumericStepper':
			return 'numeric-stepper';
		case 'AlarmSystem':
			return 'alarm-system';
		case 'RoundImageContainer':
			return 'round-image-container';

		case 'Radio':
			return 'radio';

		case 'Footer':
			return 'footer';

		case 'Address':
			return 'address';

		case 'Dropdown':
			return 'drop-down';

		case 'RatesDropdown':
			return 'rates-dropdown';

		case 'ContentBorder':
			return 'content-border';

		case 'CustomTextarea':
			return 'custom-textarea';

		case 'CustomHtml':
			return 'custom-html';
		case 'CustomeScriptInjectionHtml':
			return 'custom-script-injection-html';
		case 'ClickListening':
			return 'click-listening';

		case 'InsertNumber':
			return 'insert-number';

		case 'Sep':
			return 'sep';

		case 'CustomIcon':
			return 'custom-icon';

		case 'ExistingAccount':
			return 'existing-account';

		case 'AddressSubControl':
			return 'address-subcontrol';

		case 'SecondaryOnlineBuy':
			return 'secondary-online-buy';

		case 'CoveragePackages':
			return 'coverage-packages';

		default:
			return name;
	}
};

const ADD_CLASS = 'ADD_CLASS';
const REMOVE_CLASS = 'REMOVE_CLASS';
const modifyClassElement = (element, className, command) => {
	switch (command) {
		case ADD_CLASS:
			if (!element.classList.contains(className)) {
				element.classList.add(className);
			}
			break;
		case REMOVE_CLASS:
			if (element.classList.contains(className)) {
				element.classList.remove(className);
			}
			break;
	}
};

const freezeVp = (e) => {
	e.preventDefault();
};

export { ADD_CLASS, REMOVE_CLASS, modifyClassElement };
